module.exports = __webpack_public_path__ + "static/media/sixty_percent.80cef319.png";